'use client'

import type { Editor } from '@tiptap/react'
import { blockElementButtons } from './editor-toolbar.config'
import { EditorToolbarButtonGroup } from './editor-toolbar-button-group.atom'
import { EditorToolbarDivider } from './editor-toolbar-divider.atom'

export interface EditorToolbarBlocksProps {
  editor: Editor
  isDisabled?: boolean
}

/**
 * Block element buttons section (quote, table)
 */
export const EditorToolbarBlocks = ({ editor, isDisabled = false }: EditorToolbarBlocksProps) => (
  <>
    <EditorToolbarDivider />
    <EditorToolbarButtonGroup
      editor={editor}
      buttonList={blockElementButtons}
      isDisabled={isDisabled}
    />
  </>
)

EditorToolbarBlocks.displayName = 'EditorToolbarBlocks'
